import type { AppOperatingSystem } from "app/pages/sales-intelligence/modules/apps-search-filters/types/commonFiltersDto";

import { useAppsColumnConfigQuery } from "../query/queries/useAppsColumnConfigQuery";
import type { AppsColumnSelectionResult } from "../types/table";
import { createAppsColumnsDataFromDto } from "../utils/table";

const DEFAULT_RESULT: AppsColumnSelectionResult = {
    selectedColumnIds: [],
    categories: [],
    availableColumns: [],
};

export const useAppsColumnSelectionOptions = (appOs: AppOperatingSystem | undefined): AppsColumnSelectionResult => {
    const { data = DEFAULT_RESULT } = useAppsColumnConfigQuery(appOs, createAppsColumnsDataFromDto);

    return data;
};
